export const truckingRateConstants = {
    TRUCKING_RATE_FETCHING: 'TRUCKING_RATE_FETCHING',
    TRUCKING_RATE_FETCHED: 'TRUCKING_RATE_FETCHED',
    GET_ALL_TRUCKING_RATES: 'GET_ALL_TRUCKING_RATES',
    GET_TRUCKING_RATES: 'GET_TRUCKING_RATES',
    GET_TRUCKING_RATE_BY_ID: 'GET_TRUCKING_RATE_BY_ID',
    UPDATE_TRUCKING_RATE: 'UPDATE_TRUCKING_RATE',
    SEARCH_TRUCKING_RATES: 'SEARCH_TRUCKING_RATES',
    TRUCKINGRATE_GROUP_BY_CHARGE: 'TRUCKINGRATE_GROUP_BY_CHARGE',
    TRUCKINGRATE_GROUP_CHARGE: 'TRUCKINGRATE_GROUP_CHARGE',
    TRUCKINGRATE_GROUP_BRANCH_CHARGE: 'TRUCKINGRATE_GROUP_BRANCH_CHARGE',
}